module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": "loading",
      "size": "50px"
    }
  })], 1) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "scope col"
  }), _c('th', {
    staticClass: "scope col"
  }), _c('th', {
    staticClass: "scope col"
  }), _c('th', {
    staticClass: "scope col"
  }, [_vm._v(_vm._s(_vm.$t('integrations.title.properties_table')))])])]), _c('tbody', {
    staticClass: "scroll"
  }, _vm._l((Object.keys(_vm.dados[_vm.selected])), function(item, index) {
    return _c('tr', {
      attrs: {
        "value": item
      }
    }, [_c('td', {
      staticClass: "scope row",
      attrs: {
        "id": item
      }
    }, [_vm._v(_vm._s(item))]), _c('td', {
      attrs: {
        "id": item
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "disabled": _vm.copy_config(item),
        "data-toggle": "modal",
        "data-target": "#rd-carousel-modal"
      },
      on: {
        "click": function($event) {
          return _vm.copyConfig(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])]), _c('td', {
      attrs: {
        "id": item
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#rd-carousel-modal"
      },
      on: {
        "click": function($event) {
          return _vm.selectedCarousel(item)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.text_config(item)))])]), _c('td', {
      staticClass: "image",
      attrs: {
        "id": item
      }
    }, [_vm._l((_vm.slicePicture(item)), function(user) {
      return _c('div', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "value": user
        }
      }, [_c('img', {
        staticClass: "user",
        attrs: {
          "src": user.user.picture_url,
          "title": user.user.name
        }
      })])
    }), (_vm.dados[_vm.selected][item].Carousel) ? _c('span', {
      attrs: {
        "id": item
      }
    }, [((_vm.dados[_vm.selected][item].Carousel.carousel_users.length - 3) > 0) ? _c('button', {
      staticClass: "number_avatar",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.dropOpen(item)
        }
      }
    }, [((_vm.dados[_vm.selected][item].Carousel.carousel_users.length - 3) > 0) ? _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(_vm.dados[_vm.selected][item].Carousel.carousel_users.length - 3))]) : _vm._e()]) : _vm._e(), (_vm.active[item]) ? _c('div', {
      staticClass: "dropdown"
    }, [_c('ul', {
      staticClass: "dropimage"
    }, _vm._l((_vm.slicePictureBuble(item)), function(items) {
      return _c('li', {
        staticClass: "space",
        attrs: {
          "value": items
        }
      }, [_c('img', {
        staticClass: "user",
        attrs: {
          "src": items.user.picture_url
        }
      }), _c('span', {
        staticClass: "text_name"
      }, [_vm._v(_vm._s(items.user.name))])])
    }), 0)]) : _vm._e()]) : _vm._e()], 2)])
  }), 0), (_vm.show_modal) ? _c('carousel-modal-custom', {
    ref: "rd_carousel_modal",
    attrs: {
      "id": "rd-carousel-modal",
      "copy": _vm.datacopy,
      "modal-title": _vm.modalTitle(),
      "kind": "rd",
      "custom": _vm.custom_select,
      "dados": _vm.dados_modal,
      "custom_fields_select": _vm.selected_copy[_vm.selected]
    },
    on: {
      "carousel_updated": _vm.fillRdCarousel,
      "carousel_copy": _vm.fillRdCopy,
      "closeModal": function($event) {
        _vm.show_modal = !_vm.show_modal
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97f97c06!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/properties_table.vue
// module id = 1193
// module chunks = 1